import { publicClient, privateClient } from './client';
import { Location } from './Location';

const customLocation = (pub: boolean) => new Location(pub ? publicClient : privateClient);
export default customLocation;
